import { Typography } from "@material-tailwind/react";

const Info = () => {
    return (
        <div className="bg-blue-gray-800 min-h-screen">
            <figure className="relative gap-4 flex flex-col items-center justify-center w-full h-full bg-blue-gray-800 pb-10 pt-10">
                <figcaption className="h-min w-[calc(100%-2rem)] max-w-[350px] mx-auto px-3 sm:px-4 text-center">
                    <Typography variant="h3" color="white">
                        Informacione
                    </Typography>
                </figcaption>

                <figcaption className="w-[calc(100%-2rem)] max-w-[350px] mx-auto">
                    <div className="flex flex-col gap-6">
                        {/* About the App */}
                        <div className="rounded-xl border border-white bg-white/75 p-3 sm:p-4">
                            <Typography variant="h5" color="blue-gray" className="mb-2 font-semibold">
                                Rreth aplikacionit
                            </Typography>
                            <Typography variant="small" color="blue-gray" className="text-left font-medium">
                                Bismilah, we salatu we selamu ala rasulilah.
                                <br />
                                <br />
                                Ky aplikacion është zhvilluar nga disa vëllezër nga Kosova që të ndihmojë muslimanët në llogaritjen e kohëve të namazit, duke përfshirë gjysmën e natës dhe pjesën e tretë të natës, duke shpresuar në shpërblimin e Allahut për këtë vepër të vogël.
                                <br />
                                Kohët e namazit janë marrë nga takvimi zyrtar i Bashkësisë Islame të Kosovës.
                            </Typography>
                        </div>

                        {/* Middle Night Calculation */}
                        <div className="rounded-xl border border-white bg-white/75 p-3 sm:p-4">
                            <Typography variant="h5" color="blue-gray" className="mb-2 font-semibold">
                                Llogaritja e gjysmës së natës
                            </Typography>
                            <Typography variant="small" color="blue-gray" className="text-left font-medium">
                                Llogaritja e gjysmës së natës është bërë duke e llogaritur gjysmën e kohës nga hyrja e namazit të akshamit deri në hyrjen e kohës së sabahut, pra kohës kur lejohet falja e namazit të sabahut, që e kemi llogaritur 30 minuta pas "Imsakut" që është caktuar në takvimin e Bashkësisë Islame të Kosovës, dhe pastaj është gjetur mesi i natës.
                            </Typography>
                        </div>

                        {/* Last Third Calculation */}
                        <div className="rounded-xl border border-white bg-white/75 p-3 sm:p-4">
                            <Typography variant="h5" color="blue-gray" className="mb-2 font-semibold">
                                Llogaritja e pjesës së tretë të natës
                            </Typography>
                            <Typography variant="small" color="blue-gray" className="text-left font-medium">
                                Llogaritja e pjesës së tretë të natës është bërë njëjtë sikur llogaritja e gjysmës së natës, pra duke kalkuluar nga hyrja e namazit të akshamit sipas takvimit dhe 30 minuta pas "Imsakut" të vendosur në takvimin nga Bashkësia Islame e Kosovës, pra që llogaritet hyrja e namazit të sabahut, dhe duke e ndarë këtë kohë në 3 pjesë, kështu kemi nxjerrë pjesën e tretë të natës.
                            </Typography>
                        </div>

                        {/* Manual Calculation */}
                        <div className="rounded-xl border border-white bg-white/75 p-3 sm:p-4">
                            <Typography variant="h5" color="blue-gray" className="mb-2 font-semibold">
                                Llogaritja manuale
                            </Typography>
                            <Typography variant="small" color="blue-gray" className="text-left font-medium">
                                Llogaritja manuale është e thjeshtë, mund të bëhet për çdo shtet.
                                <br />
                                Duhet vetëm të caktoni hyrjen e kohës së namazit të akshamit në shtetin tuaj, dhe hyrjen e kohës së namazit të sabahut. Në këtë mënyrë e nxjerrim gjysmën e natës, si dhe pjesën e tretë të natës.
                            </Typography>
                        </div>

                        {/* Contact */}
                        <div className="rounded-xl border border-white bg-white/75 p-3 sm:p-4">
                            <Typography variant="h5" color="blue-gray" className="mb-2 font-semibold">
                                Kontakti
                            </Typography>
                            <Typography variant="small" color="blue-gray" className="text-left font-medium">
                                Për çdo kritikë, sygjerim apo përmirësim mund të na shkruani në emailin{" "}
                                <a href="mailto:info@muslimani.info" className="text-blue-600 hover:text-blue-800 underline">
                                    info@muslimani.info
                                </a>
                            </Typography>
                        </div>
                    </div>
                </figcaption>
            </figure>
        </div>
    );
};

export default Info;
